import { OnboardingContentWrapper } from "components/Docs/OnboardingContentWrapper";
import { GenerationEvent } from "onboarding/llm-analytics/_snippets/generation-event.tsx";
import * as React from 'react';
export default {
  OnboardingContentWrapper,
  GenerationEvent,
  React
};